import { AnimatePresence, motion } from "framer-motion";
import { useState, useEffect } from "react";
import { Pencil } from "lucide-react"; 
import Select from "react-select"; 

export default function ModalEvent({
  isEventModal,
  setIsEventModal,
  onSubmit,
  selectedDate,
  selectedEvent,
  onDelete,
  errorDate
}) {
  const [eventName, setEventName] = useState("");
  const [startDate, setStartDate] = useState(selectedDate || "");
  const [startTime, setStartTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");
  const [selectedClient, setSelectedClient] = useState(null); 
  const [selectedPodcast, setSelectedPodcast] = useState(null); 
  const [isEditing, setIsEditing] = useState(!selectedEvent); 

  const [dateError, setDateError] = useState("");

useEffect(() => {
  if (startDate && endDate && startTime && endTime) {
    const startDateTime = new Date(`${startDate}T${startTime}`);
    const endDateTime = new Date(`${endDate}T${endTime}`);

    if (endDateTime <= startDateTime) {
      setDateError("La fecha y hora de finalización deben ser posteriores a la fecha y hora de inicio.");
    } else {
      setDateError("");
    }
  }
}, [startDate, endDate, startTime, endTime]);
  

  
  const [clients, setClients] = useState([
    { value: 1, label: "Oswaldo Palacios Perez" },
    { value: 2, label: "Juan Pérez" },
    { value: 3, label: "María Gómez" },
  ]);

  const [podcasts, setPodcasts] = useState([
    { value: 1, label: "Podcast Fórmula 1" },
    { value: 2, label: "Podcast Tecnología" },
    { value: 3, label: "Podcast Ciencia" },
  ]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "var(--background)", 
      borderColor: state.isFocused ? "#3b82f6" : "#e5e7eb", 
      boxShadow: state.isFocused ? "0 0 0 1px #3b82f6" : "none", 
      "&:hover": {
        borderColor: "#3b82f6", 
      },
    }),
    input: (provided) => ({
      ...provided,
      color: "var(--text)", 
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "var(--text)", 
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "var(--text-placeholder)", 
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "var(--background-selected)" 
        : state.isFocused
        ? "var(--background-hover)" 
        : "var(--background)", 
      color: state.isSelected ? "white" : "var(--text)", 
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "var(--background)", 
    }),
  };

  useEffect(() => {
    if (selectedEvent) {
      setEventName(selectedEvent.title || "");

      const start = selectedEvent.start;
      const end = selectedEvent.end;

      if (start) {
        setStartDate(start.toISOString().split("T")[0]);
        setStartTime(start.toTimeString().split(" ")[0]);
      } else {
        setStartDate("");
        setStartTime("");
      }

      if (end) {
        setEndDate(end.toISOString().split("T")[0]);
        setEndTime(end.toTimeString().split(" ")[0]);
      } else {
        setEndDate("");
        setEndTime("");
      }

      const client = clients.find(
        (c) => c.label === selectedEvent.extendedProps?.client
      );
      const podcast = podcasts.find(
        (p) => p.label === selectedEvent.extendedProps?.podcast
      );
      setSelectedClient(client || null);
      setSelectedPodcast(podcast || null);
    } else {
      setEventName("");
      setStartDate(selectedDate || "");
      setStartTime("");
      setEndDate("");
      setEndTime("");
      setSelectedClient(null);
      setSelectedPodcast(null);
    }
  }, [selectedEvent, selectedDate, clients, podcasts]);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const startDateTime = new Date(`${startDate}T${startTime}`);
    const endDateTime = new Date(`${endDate}T${endTime}`);
  
    if (endDateTime <= startDateTime) {
      errorDate();
      return;
    }
  
    const eventData = {
      title: eventName,
      start: `${startDate}T${startTime}`,
      end: `${endDate}T${endTime}`,
      extendedProps: {
        client: selectedClient ? selectedClient.label : "",
        podcast: selectedPodcast ? selectedPodcast.label : "",
      },
    };
  
    onSubmit(eventData);
    setIsEditing(false);
  };

  return (
    <AnimatePresence>
      {isEventModal && (
        <motion.div
          key="modal-background"
          onClick={() => setIsEventModal(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-lg shadow-lg sm:p-6 p-2 font-poppins w-[500px] mx-4 border border-gray-100"
          >
            <div>
              <div className="flex justify-between items-center sm:mb-6 font-poppina ">
                <h1 className="text-xl font-semibold text-text">
                  {selectedEvent
                    ? isEditing
                      ? "Modificar evento"
                      : "Detalles del evento"
                    : "Crear evento"}
                </h1>
                {selectedEvent && !isEditing && (
                  <button
                    onClick={() => setIsEditing(true)}
                    className="text-text hover:text-blue-700"
                  >
                    <Pencil className="h-5 w-5" />
                  </button>
                )}
              </div>
              <form className="space-y-4 font-poppina " onSubmit={handleSubmit}>
              {dateError && (
  <p className="text-red-500 text-sm mt-2">{dateError}</p>
)}
                
                <div>
                  <label
                    htmlFor="eventName"
                    className="block text-sm font-medium text-text"
                  >
                    Nombre del evento
                  </label>
                  {!selectedEvent || isEditing ? (
                    <input
                      type="text"
                      id="eventName"
                      name="eventName"
                      value={eventName}
                      onChange={(e) => setEventName(e.target.value)}
                      className="mt-1 block w-full px-3 py-2 border bg-background border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Ingresa el nombre del evento"
                      required
                    />
                  ) : (
                    <p className="mt-1 block w-full px-3 py-2 bg-background rounded-md">
                      {eventName}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="startDate"
                    className="block text-sm font-medium text-text"
                  >
                    Fecha de inicio
                  </label>
                  {!selectedEvent || isEditing ? (
                    <input
                      type="date"
                      id="startDate"
                      name="startDate"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="mt-1 block w-full px-3 py-2 border bg-background border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  ) : (
                    <p className="mt-1 block w-full px-3 py-2 bg-background rounded-md">
                      {startDate}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="startTime"
                    className="block text-sm font-medium text-text"
                  >
                    Hora de inicio
                  </label>
                  {!selectedEvent || isEditing ? (
                    <input
                      type="time"
                      id="startTime"
                      name="startTime"
                      value={startTime}
                      onChange={(e) => setStartTime(e.target.value)}
                      className="mt-1 block w-full px-3 py-2 border bg-background border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  ) : (
                    <p className="mt-1 block w-full px-3 py-2 bg-background rounded-md">
                      {startTime}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="endDate"
                    className="block text-sm font-medium text-text"
                  >
                    Fecha de finalización
                  </label>
                  {!selectedEvent || isEditing ? (
                    <input
                    type="date"
                    id="endDate"
                    name="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 border bg-background border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                    min={startDate} // Deshabilita las fechas anteriores a la fecha de inicio
                  />
                  ) : (
                    <p className="mt-1 block w-full px-3 py-2 bg-background rounded-md">
                      {endDate}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="endTime"
                    className="block text-sm font-medium text-text"
                  >
                    Hora de finalización
                  </label>
                  {!selectedEvent || isEditing ? (
                    <input
                    type="time"
                    id="endTime"
                    name="endTime"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 border bg-background border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                    min={startDate === endDate ? startTime : undefined} // Deshabilita las horas anteriores si la fecha es la misma
                  />
                  ) : (
                    <p className="mt-1 block w-full px-3 py-2 bg-background rounded-md">
                      {endTime}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="client"
                    className="block text-sm font-medium text-text"
                  >
                    Cliente
                  </label>
                  {!selectedEvent || isEditing ? (
                    <Select
                      id="client"
                      name="client"
                      value={selectedClient}
                      onChange={(selectedOption) =>
                        setSelectedClient(selectedOption)
                      }
                      options={clients}
                      placeholder="Selecciona un cliente"
                      isSearchable
                      className="bg-background"
                      styles={customStyles} 
                    />
                  ) : (
                    <p className="mt-1 block w-full px-3 py-2 bg-background rounded-md">
                      Cliente: {selectedClient ? selectedClient.label : ""}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="podcast"
                    className="block text-sm font-medium text-text"
                  >
                    Podcast
                  </label>
                  {!selectedEvent || isEditing ? (
                    <Select
                      id="podcast"
                      name="podcast"
                      value={selectedPodcast}
                      onChange={(selectedOption) =>
                        setSelectedPodcast(selectedOption)
                      }
                      options={podcasts}
                      placeholder="Selecciona un podcast"
                      isSearchable
                      className="bg-background"
                      styles={customStyles} 
                    />
                  ) : (
                    <p className="mt-1 block w-full px-3 py-2 bg-background rounded-md">
                      Podcast: {selectedPodcast ? selectedPodcast.label : ""}
                    </p>
                  )}
                </div>

                <div className="flex justify-end space-x-4">
                  {selectedEvent && (
                    <button
                      type="button"
                      onClick={onDelete}
                      className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                    >
                      Eliminar
                    </button>
                  )}
                  {!selectedEvent || isEditing ? (
                    <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    disabled={!!dateError} // Deshabilita el botón si hay un error de fecha
                  >
                    {selectedEvent ? "Guardar cambios" : "Crear evento"}
                  </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => setIsEventModal(false)}
                      className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
                    >
                      Cerrar
                    </button>
                  )}
                </div>
              </form>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}